<template>
  <div>
      <h2 class="mt-5">Upload UEC</h2>
     <ExcelVue :sheet="sampleExcel" :fname="filename"/>
  </div>
</template>

<script>
import ExcelVue from "@/components/ExcelUECPnl.vue";

export default {
  components: {
    ExcelVue
},
data() {
  return {
      file: null, 
      filename:"Form_uce_pnl.xlsx",
      sampleExcel:[{ 
                    name: "SheetOne",  
                    data: [ 
                            { "origin_admin_hub":"BDO-01",
                              "destination_admin_hub":"BDO-02",
                              "origin_locker_code":"PH-Bandung",
                              "destination_locker_code":"PH-Sby",
                              "origin": "Agen Sorong",
                              "destination": "PH Kediri",
                              "type ": "Inter-PH",
                              "service":"Nextday",
                              "via": "Air",
                              "fm": 4220,
                              "feeder_intra_ph_outbound": 0,
                              "feeder_inter_ph_outbound": 0,
                              "linehaul_1": 0,
                              "linehaul_2": 0,
                              "linehaul_3": 0,
                              "linehaul_4": 0,
                              "linehaul_5": 0,
                              "linehaul_6": 0,
                              "linehaul_7": 0,
                              "linehaul_8": 0,
                              "feeder_inbound": 0,
                              "feeder_intra_ph_inbound": 0,
                              "lm":0,
                              "pp_origin":0,
                              "ph_origin":0,
                              "transit_1": 0,
                              "transit_2": 0,
                              "transit_3": 0,
                              "transit_4": 0,
                              "transit_5": 0,
                              "transit_6": 0,
                              "transit_7": 0,
                              "transit_8": 0,
                              "pp_destination":0,
                              "ph_destination":0,
                              "consumeables":0,
                              "commission":0,
                              "pp_commission":0,
                              "cos_or_shipment":0,
                              "publish_price":0,
                              "gross_margin_or_ship":0,
                              "cros_frozen_handling":0,
                              "price_frozen_handling":0,
                              "gross_margin_inc_frozen_handling":0,
                              "gross_margin_not_inc_frozen_handling_persen":0,
                              "gross_margin_inc_frozen_handling_persen":0,
                              "size":"small",
                              "is_delete":false
                            },
  
                          ] 
                    }],
    };
  },
  methods: {
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    test(){}

  },
  mounted(){
    
  }
 
};
</script>
<style scoped>
input[type="file"] {
    width: 50%;
    border: 1px solid black;
    padding: 5px 25px;
    border-radius: 5px;
}
</style>
